import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { KineticLib, fetchSpace } from '@kineticdata/react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Form } from './components/Form';
import { PageTitle } from './components/PageTitle';
import emoryLogo from './assets/emory-logo.png';

const Header = () => (
  <header className="public">
    <img src={emoryLogo} className="header-logo" alt="Emory logo" />
    {/* <h1>Public Forms</h1> */}
  </header>
);

export const NotFound = () => <h1>Page Not Found</h1>;

export const Confirmation = () => <h1>Thank you for your submission</h1>;

export const EmptyApp = () => <h1>Loading...</h1>;

export const App = () => {
  // fetch and set default kapp
  const [defaultKapp, setDefaultKapp] = useState('public');
  useEffect(() => {
    async function fetchDefaultKappRequest() {
      let response = await fetchSpace({
        public: true,
        include: 'attributesMap',
      });
      setDefaultKapp(
        response.space.attributesMap['Default Kapp']
          ? response.space.attributesMap['Default Kapp'][0]
          : 'public',
      );
    }
    fetchDefaultKappRequest();
  }, []);

  return (
    <KineticLib components={{ EmptyApp }} locale="en">
      {({ initialized }) => (
        <>
          <PageTitle title="Public Forms" />
          <Header />
          {!initialized ? (
            <h1>Loading...</h1>
          ) : (
            <div className="app-container">
              <main>
                <Switch>
                  <Route path="/confirmation" component={Confirmation} exact />
                  <Redirect
                    path="/kapps/:kappSlug/forms/:formSlug"
                    to={`/:formSlug`}
                  />
                  <Route
                    path="/:formSlug"
                    render={() => <Form defaultKapp={defaultKapp} />}
                    exact
                  />
                  <Route component={NotFound} />
                </Switch>
              </main>
            </div>
          )}
        </>
      )}
    </KineticLib>
  );
};
